/* Single sprite source for homepage X-ray and Plasma. */
window.KotlieAirParticles=window.KotlieAirParticles||{
 colors:{intake:[255,235,192],treated:[77,184,111]},
 createSprites(colors=this.colors){const particleSprites={};
 for(const key of ['intake','treated','intake-bright','treated-bright']){
  const bright=key.endsWith('-bright'),base=colors[key.replace('-bright','')];const color=bright?(key.startsWith("intake")?[255, 245, 218]:[123, 247, 156]):base;particleSprites[key]=[];
  for(let i=0;i<32;i++){
   const sprite=document.createElement('canvas');sprite.width=32;sprite.height=32;
   const c=sprite.getContext('2d');c.translate(16,16);c.rotate(i*Math.PI*2/32);
   // Soft same-color head and short tail are rasterized once, never stroked per frame.
   if(bright){
    const bloom=c.createRadialGradient(0,0,1,0,0,8);
    bloom.addColorStop(0,`rgba(${color},.20)`);bloom.addColorStop(.4,`rgba(${color},.085)`);bloom.addColorStop(1,`rgba(${color},0)`);
    c.fillStyle=bloom;c.fillRect(-8,-8,16,16);
   }
   const halo=c.createRadialGradient(0,0,0,0,0,4.5);
   halo.addColorStop(0,`rgba(${color},${bright?.85:.12})`);halo.addColorStop(.25,`rgba(${color},${bright?.32:.035})`);halo.addColorStop(1,`rgba(${color},0)`);
   c.fillStyle=halo;c.fillRect(-5,-5,10,10);
   c.save();c.scale(1,1);const g=c.createRadialGradient(0,0,0,0,0,2.6);
   g.addColorStop(0,`rgba(${color},1)`);g.addColorStop(.42,`rgba(${color},.8)`);g.addColorStop(1,`rgba(${color},0)`);
   c.fillStyle=g;c.fillRect(-4,-4,8,8);c.restore();
   if(bright){const tail=c.createLinearGradient(-7,0,0,0);tail.addColorStop(0,`rgba(${color},0)`);tail.addColorStop(.65,`rgba(${color},.24)`);tail.addColorStop(1,`rgba(${color},.65)`);
   c.fillStyle=tail;c.beginPath();c.moveTo(-7,0);c.quadraticCurveTo(-3,-1.5,0,-1);c.lineTo(0,1);c.quadraticCurveTo(-3,1.5,-7,0);c.fill();}
   particleSprites[key].push(sprite);
  }
 }
return particleSprites;},
 screenScale(radius,z,portDistance,referenceWidth){
 const smooth=t=>{t=Math.max(0,Math.min(1,t));return t*t*(3-2*t)};
 const depth=.8+z*.38,weight=smooth((portDistance-80)/70),depthSize=1+weight*((.88+.24*z)-1);
 return radius*.7*depth*Math.sqrt(Math.max(1,Math.min(1.75,650/referenceWidth)))*depthSize*referenceWidth/1532;
 }
};
